module.exports = __webpack_public_path__ + "img/home-w.svg";